export default __webpack_public_path__ + "static/media/5.19f80f18.webp";